module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_vm._v("C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/007_Foreword#fm-1"
    }
  }, [_c('em', [_vm._v("Foreword")]), _vm._v(" by Sara Wilhelm Garbers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Preface#fm-2"
    }
  }, [_c('em', [_vm._v("Preface")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Ack#fm-3"
    }
  }, [_c('em', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm1"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#fm-4"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#ch-1"
    }
  }, [_c('span', {
    staticClass: "pad"
  }, [_vm._v("1.")]), _vm._v(" “YHWH Has Become King”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#ch-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "pad"
  }, [_vm._v("2.")]), _vm._v(" The Hopes of the Prophets")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter03#ch-3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "pad"
  }, [_vm._v("3.")]), _vm._v(" The Day of YHWH’s Apocalypse")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04#ch-4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "pad"
  }, [_vm._v("4.")]), _vm._v(" “The Kingdom of God Is in Your Midst”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05#ch-5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "pad"
  }, [_vm._v("5.")]), _vm._v(" The Way of the Kingdom")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06#ch-6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "pad"
  }, [_vm._v("6.")]), _vm._v(" “Thy Kingdom Come!”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm1"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Conclusion#bm-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Bibliography#bm-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Bibliography")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c55e195","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/006_Contents.vue
// module id = 72
// module chunks = 0